import {
    LeaderBoardInfo,
    LeaderboardMappedResult
  } from '@/core/interfaces';
  
export const LeaderboardMapper = ({
    users,
    totalTapPoints,
    userRank
}: LeaderBoardInfo): LeaderboardMappedResult => {
    const leaderboard = Object.entries(users)
      .map(([userId, points]) => {
        const username = userId.replace(/_\d+$/, "");
        return { userId: username, points };
      })
      .sort((a, b) => b.points - a.points);
  
    return {
      totalTapPoints,
      leaderboard,
      userRank
    };
};